import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function AboutPage() {
  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 吉泽明步粉丝资讯站',
    description: '吉泽明步粉丝资讯站，由粉丝自发创建，致力于为全球粉丝提供最全面、最权威的吉泽明步相关资讯。',
    url: 'https://yoshizawa-fans.com/about',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <title>关于我们 - 吉泽明步粉丝资讯站</title>
      <meta name="description" content="吉泽明步粉丝资讯站，由粉丝自发创建，致力于为全球粉丝提供最全面、最权威的吉泽明步相关资讯。了解我们的品牌故事、口碑信誉与联系方式。" />
      <meta name="keywords" content="吉泽明步,关于我们,粉丝资讯站,联系方式,品牌介绍" />
      <link rel="canonical" href="https://yoshizawa-fans.com/about" />
      <meta property="og:title" content="关于我们 - 吉泽明步粉丝资讯站" />
      <meta property="og:description" content="吉泽明步粉丝资讯站，由粉丝自发创建，致力于为全球粉丝提供最全面、最权威的吉泽明步相关资讯。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://yoshizawa-fans.com/about" />

      <Navbar />
      <Breadcrumb />

      <main className="min-h-screen bg-background-50">
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              关于我们
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              吉泽明步粉丝资讯站由一群热爱吉泽明步的粉丝于2024年创建，旨在为全球粉丝提供一个全面、权威的吉泽明步资讯平台。
            </p>
          </div>
        </section>

        <section className="py-14 md:py-20">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-5">
                  品牌故事
                </h2>
                <div className="flex flex-col gap-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    吉泽明步粉丝资讯站（Akiho Fans）诞生于2024年春天。几位志同道合的吉泽明步粉丝发现，网络上关于她的信息虽然丰富但非常零散，缺乏一个系统、权威的整合平台。于是，他们决定联手打造这个专门面向吉泽明步粉丝的资讯站点。
                  </p>
                  <p>
                    我们的使命非常简单：汇聚关于吉泽明步最全面、最准确的信息，让每一位粉丝——无论是初次了解还是多年追随——都能在这里找到所需的资讯。从个人资料到演艺经历，从代表作品到最新动态，我们致力于做到应尽应有。
                  </p>
                  <p>
                    本站的内容由编辑团队精心整理和撰写，坚持客观、准确、尊重事实的基本原则。我们不会发布未经证实的传言或未经官方认可的信息，力求成为粉丝群体中最值得信赖的信息来源。
                  </p>
                </div>
              </div>

              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-5">
                  口碑信誉
                </h2>
                <div className="flex flex-col gap-5">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-shield-check-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-sm text-foreground-900 mb-1">信息准确性</h4>
                      <p className="text-xs text-foreground-500 leading-relaxed">
                        所有信息均经过多方核实与交叉验证，确保内容的真实性和准确性，杜绝虚假信息传播。
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-timer-flash-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-sm text-foreground-900 mb-1">更新及时</h4>
                      <p className="text-xs text-foreground-500 leading-relaxed">
                        编辑团队保持对吉泽明步动态的持续关注，确保网站内容在最短时间内得到更新，让粉丝获得第一手资讯。
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-user-heart-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-sm text-foreground-900 mb-1">粉丝至上</h4>
                      <p className="text-xs text-foreground-500 leading-relaxed">
                        我们从粉丝的视角出发设计网站内容和功能，力求提供最好的阅读体验和最便捷的信息获取方式。
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-community-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-sm text-foreground-900 mb-1">社区共建</h4>
                      <p className="text-xs text-foreground-500 leading-relaxed">
                        我们欢迎粉丝提供信息线索和内容建议，通过社区共建的方式不断完善网站内容，实现共同成长。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-12">
              <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h4 className="font-semibold text-sm text-foreground-900 mb-1">电子邮件</h4>
                <p className="text-xs text-foreground-500">contact@akihofans.com</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h4 className="font-semibold text-sm text-foreground-900 mb-1">所在地</h4>
                <p className="text-xs text-foreground-500">日本东京都</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className="ri-time-line text-xl"></i>
                </div>
                <h4 className="font-semibold text-sm text-foreground-900 mb-1">工作时间</h4>
                <p className="text-xs text-foreground-500">周一至周五 10:00-18:00</p>
              </div>
            </div>

            <ContactForm />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

function ContactForm() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;

    if (honeypot && honeypot.trim() !== '') {
      alert('感谢您的留言，我们会尽快回复！');
      form.reset();
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9rf63fnahb7382ovlig', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        alert('感谢您的留言，我们会尽快回复！');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        alert(serverMsg);
      }
    } catch {
      alert('网络错误，请稍后重试');
    }
  };

  return (
    <div className="max-w-lg mx-auto">
      <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-5 text-center">
        发送留言
      </h3>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-readdy-form="">
        <input type="text" name="name" required placeholder="您的姓名" className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors" />
        <input type="email" name="email" required placeholder="您的邮箱" className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors" />
        <input type="text" name="subject" required placeholder="主题" className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors" />
        <textarea name="message" required placeholder="请在此输入您的留言（500字以内）" maxLength={500} rows={4} className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"></textarea>

        <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />

        <button type="submit" className="w-full py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap">
          发送留言
        </button>
      </form>
    </div>
  );
}